import type { IconData } from '@stacksjs/iconify-core'

export const diamond1Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M36.915 5.5a4.5 4.5 0 0 1 3.92 2.289l5.352 9.49a4.5 4.5 0 0 1-.737 5.393L26.475 41.646a3.5 3.5 0 0 1-4.95 0L2.551 22.672a4.5 4.5 0 0 1-.738-5.393l5.353-9.49a4.5 4.5 0 0 1 3.92-2.289z\"/><path fill=\"#2859c5\" d=\"M30.841 5.5H27.77l2.863 13H17.366l2.863-13h-3.072l-2.863 13H1.342a4.5 4.5 0 0 0 .364 3h12.706l5.6 18.633l1.513 1.513a3.5 3.5 0 0 0 2.382 1.024L17.544 21.5h12.91l-6.362 21.17a3.5 3.5 0 0 0 2.383-1.024l1.511-1.51l5.6-18.636h12.708a4.5 4.5 0 0 0 .364-3H33.705z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default diamond1Flat
